//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);
export default {
  data() {
    return {
      loading: false,
      object_id: null,
      objectInfo: null,
      fieldList: [], // 字段列表
      list: [],
      // 新增
      addDialog: false,
      addForm: {
        index_name: '',
        description: '',
        object_id: '',
        fields: [],
        is_unique: false,
        useDefault: false,
      },
      prefix: 'idx_', // index_name idx_开头，如果is_unique为true就uidx_开头
      rules: {
        index_name: [
          {
            validator: (rule, value, callback) => {
              if (this.prefix.length + value.length > 63) {
                callback(new Error('字数超过限制'));
                return;
              }
              callback();
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        metaManage: this.getElementList.includes('meta-manage'),
      };
    },
    defaultIndexName() {
      const time = Number.parseInt(Date.parse(new Date()) / 1000);
      // 默认索引名: 对象名，再加字段名用_相连,最后加个_时间戳(用户未输入)
      const indexName = `${this.objectInfo.name}_${this.addForm.fields.join('_')}_${time}`;
      const name = `${this.prefix}${indexName}`;
      if (name.length > 63) {
        return indexName.substring(0, 63 - this.prefix.length);
      }
      return indexName;
    },
  },
  created() {
    this.object_id = this.$route.query.object_id;
    this.getList(this.object_id);

    this.getObjectInfo(this.object_id);
    this.getFieldList(this.object_id);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    humanifyDate(str) {
      return dayjs(str).format('lll');
    },
    relativeDate(str) {
      return dayjs(str).fromNow();
    },
    getList(object_id = this.object_id) {
      this.loading = true;
      this.$request({
        url: this.$api.metaGetIndexesByObjectID,
        data: { object_id },
        cb: ({ index }) => {
          this.list = index;
          this.loading = false;
        },
      });
    },
    // 获取表信息
    getObjectInfo(objectId) {
      this.$request({
        url: this.$api.metaGetObjectDetail,
        data: { id: objectId },
        cb: ({ object }) => {
          this.objectInfo = object;
        },
      });
    },
    // 获取字段列表
    getFieldList(objectId) {
      this.$request({
        url: this.$api.metaGetObjectFields,
        data: { object_id: objectId },
        cb: ({ fields }) => {
          this.fieldList = fields;
        },
      });
    },
    // 新增
    openAddDialog() {
      this.prefix = 'idx_';
      this.addForm = {
        index_name: '',
        description: '',
        object_id: '',
        fields: [],
        is_unique: false,
        type: 'BTREE',
        useDefault: false,
      };
      this.$nextTick(() => {
        this.addDialog = true;
      });
    },
    uniqueChange(value) {
      switch (value) {
        case false:
          this.prefix = 'idx_';
          break;
        case true:
          this.prefix = 'uidx_';
      }
    },
    add() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const { index_name: indexName, useDefault } = this.addForm;
          let name = '';
          if (useDefault) {
            name = this.defaultIndexName;
          } else {
            // 未输入时使用默认索引名
            name = indexName || this.defaultIndexName;
          }
          const index = {
            ...this.addForm,
            object_id: this.object_id,
            index_name: `${this.prefix}${name}`,
          };
          delete index.useDefault;
          this.$request({
            url: this.$api.metaAddIndex,
            data: {
              index,
            },
            cb: () => {
              this.addDialog = false;
              this.getList();
            },
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    itemDelete({ id }) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$request({
            url: this.$api.metaDeleteIndex,
            data: { id },
            cb: () => {
              this.getList();
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            },
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
